export const REQUEST_GET_LEAD = 'dashboard/REQUEST_GET_LEAD';
export const REQUEST_GET_ORDER = 'dashboard/REQUEST_GET_ORDER';
export const REQUEST_GET_INVOICE = 'dashboard/REQUEST_GET_INVOICE';
export const REQUEST_GET_USER = 'dashboard/REQUEST_GET_LEAD';

export const RECEIVED_GET_LEAD = 'dashboard/RECEIVED_GET_LEAD';
export const RECEIVED_GET_ORDER = 'dashboard/RECEIVED_GET_ORDER';
export const RECEIVED_GET_INVOICE = 'dashboard/RECEIVED_GET_INVOICE';
export const RECEIVED_GET_USER = 'dashboard/RECEIVED_GET_USER';
export const RECEIVED_GET_PRODUCT = 'dashboard/RECEIVED_GET_PRODUCT';

